import { apiGet, apiBasic } from "./requests";

export const getCatalogs = (query) => {
  let path = "catalogs/";
  return apiGet(path, query);
};

export const createCatalog = (data) => {
  let path = "catalogs/";
  return apiBasic(data, path, "post");
};

export const updateCatalog = (id, data) => {
  let path = `catalog/${id}/`;
  return apiBasic(data, path, "patch");
};

export const toggleCatalogStatus = (id) => {
  let path = `catalog/toggle-active-status/${id}`;
  return /*apiGet(path);*/ apiBasic({}, path, "patch");
};

// Activar/desactivar productos en un catálogo
export const toggleProductsStatusInCatalog = (catalogId, productIds) => {
  let path = `catalog/${catalogId}/toggle-state-products`;
  return apiBasic({ productIds }, path, "patch");
};

// Sincronizar los productos seleccionados en el catálogo.
export const updateCatalogProducts = (catalogId, productIds) => {
  const path = `catalog/${catalogId}/update-products`;
  return apiBasic({ productIds }, path, "post");
};

export const getProductsNotInCatalog = (catalogId) => {
  let path = `catalog/unassigned-products/${catalogId}`;
  return apiGet(path);
};

export const deleteBatchCatalogs = (catalogIds) => {
  let path = `catalogs/delete-catalogs`;
  return apiBasic({ catalogIds }, path, "delete");
};
